import { Box, Drawer } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useBreakpoints } from "src/hooks";
import { DrawerContext, type IDrawerOptions } from "./DrawerContext";
import { ResizeableDrawer } from "./ResizeableDrawer";

interface IProps {
  children: React.ReactNode;
}

const DrawerProvider = (props: IProps) => {
  const [content, setContent] = useState<React.ReactNode | undefined>(undefined);
  const location = useLocation();
  const { isMdUp } = useBreakpoints();

  useEffect(() => {
    if (!isMdUp) {
      setContent(undefined);
    }
  }, [isMdUp, location]);

  function showDrawer(options: IDrawerOptions) {
    setContent(options.content);
  }

  function closeDrawer() {
    setContent(undefined);
  }

  return (
    <DrawerContext.Provider
      value={{
        showDrawer,
        closeDrawer,
        isOpen: content !== undefined,
      }}
    >
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flexShrink: 1, flexGrow: 1, minWidth: 0 }}>{props.children}</Box>

        {isMdUp ? (
          <ResizeableDrawer open={content !== undefined}>{content}</ResizeableDrawer>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={content !== undefined}
            onClose={closeDrawer}
            slotProps={{
              paper: {
                sx: {
                  backgroundColor: "#fff",
                },
              },
            }}
            sx={{
              width: "80vw",
            }}
          >
            {content}
          </Drawer>
        )}
      </Box>
    </DrawerContext.Provider>
  );
};

export { DrawerProvider, type IDrawerOptions };
